/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalRegisterDataRequest
 */
export interface AdditionalRegisterDataRequest {
    /**
     * 
     * @type {string}
     * @memberof AdditionalRegisterDataRequest
     */
    objectId: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalRegisterDataRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalRegisterDataRequest
     */
    email: string;
}

/**
 * Check if a given object implements the AdditionalRegisterDataRequest interface.
 */
export function instanceOfAdditionalRegisterDataRequest(value: object): value is AdditionalRegisterDataRequest {
    if (!('objectId' in value) || value['objectId'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AdditionalRegisterDataRequestFromJSON(json: any): AdditionalRegisterDataRequest {
    return AdditionalRegisterDataRequestFromJSONTyped(json, false);
}

export function AdditionalRegisterDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalRegisterDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'objectId': json['objectId'],
        'password': json['password'],
        'email': json['email'],
    };
}

export function AdditionalRegisterDataRequestToJSON(json: any): AdditionalRegisterDataRequest {
    return AdditionalRegisterDataRequestToJSONTyped(json, false);
}

export function AdditionalRegisterDataRequestToJSONTyped(value?: AdditionalRegisterDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectId': value['objectId'],
        'password': value['password'],
        'email': value['email'],
    };
}

